import axios from '@/util/axios'
import { API_RELAY_PATH } from '@/util/constants'
import store from '@/store'

/**
 * 支払い方法取得
 */
export const fetchPaymentMethod = (params = {}) => {
  const defaults = {
    _path: 'SN/001',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 請求書一覧取得
 */
export const listInvoices = (params = {}) => {
  const defaults = {
    _path: 'SN/002',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 請求書・代金明細出力
 */
export const outputInvoices = (params = {}) => {
  const defaults = {
    _path: 'SN/003',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 顧客情報同期
 */
export const synchronizeCustomerInfo = (params = {}) => {
  const defaults = {
    _path: 'AD/SN/004',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 自動決済有効
 */
export const enableAutomaticPayment = (params = {}) => {
  const defaults = {
    _path: 'AD/SN/005',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}


/**
 * 自動決済解約API		
 */
export const cancelAutomaticPayment = (params = {}) => {
  const defaults = {
    _path: 'AD/SN/006',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 商品同期
 */
export const synchronizeProducts = (params = {}) => {
  const defaults = {
    _path: 'AD/SN/007',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * WEB会員認証API
 */
export const authenticateWebMember = (params = {}) => {
  const defaults = {
    _path: 'SN/008',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 支払い方法指定
 */
export const setPaymentMethod = (params = {}) => {
  const defaults = {
    _path: 'SN/009',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 申請情報取得
 */
export const fetchApplicationInfo = (params = {}) => {
  const defaults = {
    _path: 'SN/010',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}
